module.exports = __webpack_public_path__ + "img/nfc-slash.b06d2770.svg";